<template>
  <div>
    <v-row v-for="(item, index) in itemsProxy" :key="index">
      <v-col cols="1" md="1">
        <v-subheader class="text-subtitle-1 font-weight-medium justify-end pr-0 mt-n1">
          {{ index + 1 }}.
        </v-subheader>
      </v-col>

      <v-col cols="10" md="10">
        <v-textarea
          :value="item.value"
          @input="updateItem(index, $event)"
          rows="1"
          outlined
          dense
          hide-details
          auto-grow
          class="text-body-2"
        />
      </v-col>

      <v-col cols="1" md="1">
        <v-btn
          fab
          dark
          x-small
          color="secundary"
          width="20"
          height="20"
          v-show="itemsProxy.length > 1"
          @click="deleteItem(index)"
        >
          <v-icon dark>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="text-start ml-10 py-0">
      <v-btn fab dark color="primary" x-small @click="addItem">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <span class="text-end text-caption mt-3 mr-16 pr-4">
        No ingrese ningún dato personal que permita identificar al paciente.
      </span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'VItemsAddRemove',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    itemsProxy: {
      get() {
        return Array.isArray(this.items) ? this.items : [];
      },
      set(value) {
        this.$emit('update:items', value);
      }
    }
  },

  mounted() {
    if (!this.items || this.items.length === 0) {
      this.itemsProxy = [{ value: '' }];
    }
  },

  watch: {
    items: {
      immediate: true,
      handler(newValue) {
        if (!newValue || newValue.length === 0) {
          // Emitimos al padre que necesitamos al menos un item vacío
          this.$emit('update:items', [{ value: '' }]);
        }
      }
    }
  },

  methods: {
    addItem() {
      this.itemsProxy = [...this.itemsProxy, { value: '' }];
    },

    deleteItem(index) {
      if (this.itemsProxy.length <= 1) return;

      this.itemsProxy = this.itemsProxy.filter((_, i) => i !== index);
    },

    updateItem(index, value) {
      const updated = [...this.itemsProxy];
      updated[index] = { ...updated[index], value };
      this.itemsProxy = updated;
    }
  }
};
</script>